import React, { createContext, useEffect, useState } from 'react';
import { Router, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { history } from './utils/variables';

//components
import Header from './components/master/Header';
import Footer from './components/master/Footer';

//pages
import Home from './pages/master/Home';
import About from './pages/master/About';
import Login from './pages/master/Login';
import Waiting from './pages/client/Waiting';
import LossesAccident from './pages/client/LossesAccident';
import UserImages from './pages/client/UserImages';
import Success from './pages/master/Success';
import Tutorial from './pages/master/Tutorial';
import ReportList from './pages/master/ReportList';
import ReportSingle from './pages/master/ReportSingle';
import EditProfile from './pages/master/EditProfile';
import Register from './pages/register/Register';
import RegisterList from './pages/register/RegisterList';
import RegisterSingle from './pages/register/RegisterSingle';
import RegisterImages from './pages/register/RegisterImages';
import RegisterPricing from './pages/register/RegisterPricing';
import ExpertWaiting from './pages/expert/ExpertWaiting';
import ExpertMap from './pages/expert/ExpertMap';
import CulpritDetail from './pages/expert/CulpritDetail';
import LossesDetail from './pages/expert/LossesDetail';
import ExpertImages from './pages/expert/ExpertImages';
import FinalPricing from './pages/expert/FinalPricing';
import Review from './pages/expert/Review';
import EditReport from './pages/expert/EditReport';
import Rules from './pages/master/Rules';
import Wallet from './pages/expert/Wallet';
import Development from './pages/dev/Development';
import ThirdPartyLogin from './pages/client/ThirdPartyLogin';
import UserInfo from './pages/client/UserInfo';
import Error from './pages/master/Error';
import Receipt from './components/pages/receipt';
import Payment from './components/master/Payment';
import { useSelector } from 'react-redux';
import { Plans } from './pages/client/Plans';
import AccidentReport from './pages/client/AccidentReport';
import SelectExpert from './pages/client/SelectExpert';
import GetLocation from './pages/client/GetLocation';
// import ExpertInfo from './pages/client/ExpertInfo';
import LossesInfo from './pages/client/LossesInfo';
import AccidentType from './pages/client/AccidentType';
import Razi from './assets/images/logo/insurance-logo/razi/196.png'
import Complete from './pages/client/Complete';
import AssessType from './pages/client/AssessType';
import ImagesComplement from './pages/client/ImagesComplement';
import RegisterData from './components/pages/register/Data';
import RegisterVideo from './components/pages/register/Video';
import RegisterCapturing from './components/pages/register/Images';
import FinalImages from './pages/expert/FinalImages';

export const TitleContext = createContext('');
export default function App() {
    const {language ,theme,insuranceCode} = useSelector(store=> store)
    // const [title, setTitle] = useState('');
    const insurancesIdentity = [
        {code : 'h4Si7nx9',title:'بیمه ایران',icon:''},
        {code : 'w0Rg6c2j',title:'بیمه سینا',icon:''},
        {code : 'r65wX12j',title:'بیمه رازی',icon:Razi},
        {code : 'z0Qn5ke2',title:'بیمه آرمان',icon:''},
        {code : 'hj6Fy2wa1',title:'بیمه حافظ',icon:''},
        {code : 'l0Qg2kd4',title:'بیمه تجارت نو',icon:''},
        {code : 'u2Kc4jw8',title:'بیمه سرمد',icon:''},
        {code : 'p9Ld3xc4',title:'بیمه دی',icon:''},
        {code : 'l9Rx6eo2',title:'بیمه بازار',icon:''},
        {code : 'q3Rx4jw5',title:'بیمه البرز',icon:''},
        {code : 'i6Xd8gq3',title:'بیمه مرکزی',icon:''},
        {code : 'c5Hs5vq0',title:'بیمه امید',icon:''},
    ]

    useEffect(()=>{
        document.documentElement.setAttribute("data-theme",theme)
    },[theme])
    useEffect(()=>{
        if(insuranceCode) {
            const currentInsurance = insurancesIdentity.filter((insu)=>insu.code === insuranceCode)[0]
            document.title = currentInsurance.title
            // const link = document.querySelector("link[rel*='icon']")
            // const description = document.querySelector("meta[name*='description']")
            // link.href = currentInsurance.icon;
            // description.content = currentInsurance.title
        }else {
            document.title = 'بالن'
        }
    },[insuranceCode])
    return (
            // <TitleContext.Provider value={{title,setTitle}}>
        <div className={`App ${(language.lang === 'en' || language.lang === 'ru')? 'lr': ''}`}> 
            <ToastContainer />
            <Router history={history}>
                <div className='container'>
                    <Header />
                    <Route path='/' component={Home} exact />
                    <Route path='/tutorial' component={Tutorial} />
                    <Route path='/about' component={About} />
                    <Route path='/login' component={Login} />
                    <Route path='/waiting' component={Waiting} />
                    <Route path='/losses-accident' component={LossesAccident} />
                    <Route path='/user-images' component={UserImages} />
                    <Route path='/success/:id' component={Success} />
                    <Route path='/report-list' component={ReportList} />
                    <Route path='/report-single/:id?' component={ReportSingle} />
                    <Route path='/edit-profile' component={EditProfile} />
                    <Route path='/register' component={Register} />
                    <Route path='/register-list' component={RegisterList} />
                    <Route path='/register-single' component={RegisterSingle} />
                    <Route path='/register-images' component={RegisterImages} />
                    <Route path='/register-pricing' component={RegisterPricing} />
                    <Route path='/expert-waiting' component={ExpertWaiting} />
                    <Route path='/expert-map' component={ExpertMap} />
                    <Route path='/culprit-detail' component={CulpritDetail} />
                    <Route path='/losses-detail' component={LossesDetail} />
                    <Route path='/expert-images' component={ExpertImages} />
                    <Route path='/final-pricing' component={FinalPricing} />
                    <Route path='/review' component={Review} />
                    <Route path='/edit-report/:type?' component={EditReport} />
                    <Route path='/rules' component={Rules} />
                    <Route path='/wallet' component={Wallet} />
                    <Route path='/development' component={Development} />
                    <Route path='/third-party-login' component={ThirdPartyLogin} />
                    <Route path='/user-info' component={UserInfo} />
                    <Route path='/error' component={Error} />
                    <Route path='/receipt' component={Receipt}/>
                    <Route path='/payment' component={Payment}/>
                    <Route path='/plans' component={Plans}/>
                    <Route path='/accident-report' component={AccidentReport}/>
                    <Route path='/select-expert' component={SelectExpert}/>
                    <Route path='/get_location' component={GetLocation}/>
                    {/* <Route path='/expert-info' component={ExpertInfo}/> */}
                    <Route path='/losses-info' component={LossesInfo}/>
                    <Route path='/accident-type' component={AccidentType}/>
                    <Route path='/complete' component={Complete}/>
                    <Route path='/assess-type' component={AssessType}/>
                    <Route path='/images-complement' component={ImagesComplement}/>
                    <Route path='/register-data' component={RegisterData}/>
                    <Route path='/register-capturing' component={RegisterCapturing}/>
                    <Route path='/register-video' component={RegisterVideo}/>
                    <Route path='/final-images' component={FinalImages}/>
                    <Footer />
                </div>
            </Router>
        </div>
        // </TitleContext.Provider>
    );

}
